module.exports = __webpack_public_path__ + "static/gallery_05-9e06aea392ae2beef4626573a2cab92c.jpg";